module.exports = __webpack_public_path__ + "static/media/react.e1099df7.png";